/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlansResult } from '../../models/get-plans-result';

export interface ApiAdminBillingPlansGet$Params {
}

export function apiAdminBillingPlansGet(http: HttpClient, rootUrl: string, params?: ApiAdminBillingPlansGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBillingPlansGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlansResult>;
    })
  );
}

apiAdminBillingPlansGet.PATH = '/api/Admin/billing/plans';
